import { singUpActions } from "./signup/index";
import { countryCodeActions } from "./countryCodes/index";
import { authActions } from "./auth";
import { businessTypeActions } from "./businessType";
import { trainingGroupActions } from "./trainingGroup";
import { shopcardActions } from "./shopCard";
import { templateActions } from "./template";
import { meberActions } from "./member";
import { userCamDigitActions } from "./confirmAccount";
export default {
  act_changLanguage: ({ commit }, payload) => {
    commit("changLanguage", payload);
  },
  ...singUpActions,
  ...countryCodeActions,
  ...authActions,
  ...businessTypeActions,
  ...trainingGroupActions,
  ...shopcardActions,
  ...templateActions,
  ...meberActions,
  ...userCamDigitActions
};
